import { render, staticRenderFns } from "./GlobalIndicatorsChartLegend.vue?vue&type=template&id=e6bcecee&"
import script from "./GlobalIndicatorsChartLegend.vue?vue&type=script&lang=ts&"
export * from "./GlobalIndicatorsChartLegend.vue?vue&type=script&lang=ts&"
import style0 from "./GlobalIndicatorsChartLegend.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports